import { Feedback } from '../../constants/apis';
import type {
  FeedbackFilterType,
  FeedbackPageType,
  FeedbackSortType,
  FeedbackTopicType,
  Feedback as FeedbackParent,
} from '../../types/feedbacks';
import { ApiManager } from '../axios-config';

type FetchFeedbackArg = {
  offset: number;
  topicId: string;
  topicType: FeedbackTopicType;
  sort: FeedbackSortType['apiValue'];
  filter?: FeedbackFilterType['value'];
  token?: string;
};

export const fetchFeedbacks = async ({
  offset,
  topicId,
  sort,
  filter,
  token,
  topicType,
}: FetchFeedbackArg) => {
  const feedbackUrl = new URL(Feedback);
  const params = new URLSearchParams({
    topicId,
    topicType,
    sortBy: sort,
    offset: offset.toString(),
    size: '10',
    commentDepthLevel: '5',
  });
  if (filter && filter !== 'Mine' && filter !== 'All') {
    params.append('type', filter);
  }
  if (filter === 'Mine') {
    params.append('OnlyCurrentUser', 'true');
  }
  feedbackUrl.search = params.toString();

  return ApiManager.get<FeedbackPageType>(feedbackUrl.toString(), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getFeedbackThread = async (feedbackId: string, token?: string) => {
  return ApiManager.get<FeedbackParent>(`${Feedback}/${feedbackId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
